module.exports = __webpack_public_path__ + "img/cpzz2@2x.f983c6e6.png";